import { render, staticRenderFns } from "./list_detail.vue?vue&type=template&id=c9129d98&"
import script from "./list_detail.vue?vue&type=script&lang=js&"
export * from "./list_detail.vue?vue&type=script&lang=js&"
import style0 from "./list_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports